import { useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default icon paths for Create React App
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

/**
 * Sub-componente que recentra el mapa cuando cambian las coordenadas desde afuera
 * (ejemplo: cuando el usuario presiona "Mi ubicación actual")
 */
function MapCenterUpdater({ center }) {
  const map = useMap();
  useEffect(() => {
    if (center) {
      map.setView([center.lat, center.lng], map.getZoom(), { animate: true });
    }
  }, [center, map]);
  return null;
}

/**
 * Sub-componente que escucha los clicks en el mapa y actualiza la posición del pin
 */
function MapClickHandler({ onPositionChange }) {
  useMapEvents({
    click(e) {
      onPositionChange({ lat: e.latlng.lat, lng: e.latlng.lng });
    },
  });
  return null;
}

/**
 * Componente principal del selector de mapa
 * - Usa Leaflet + OpenStreetMap (100% gratuito, sin API key)
 * - Permite hacer clic en el mapa para mover el pin
 * - Permite arrastrar el pin
 * - Recibe `center` desde afuera para centrar el mapa (ej: geolocalización)
 */
export default function AddressMapSelector({ position, onPositionChange, center }) {
  const markerRef = useRef(null);

  const handleDragEnd = () => {
    const marker = markerRef.current;
    if (marker) {
      const latlng = marker.getLatLng();
      onPositionChange({ lat: latlng.lat, lng: latlng.lng });
    }
  };

  return (
    <MapContainer
      center={[position.lat, position.lng]}
      zoom={15}
      style={{ width: "100%", height: "100%" }}
      scrollWheelZoom={true}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {/* Actualiza el centro del mapa cuando se obtiene la ubicación del usuario */}
      <MapCenterUpdater center={center} />
      {/* Maneja los clicks en el mapa */}
      <MapClickHandler onPositionChange={onPositionChange} />
      {/* Marcador arrastrable */}
      <Marker
        position={[position.lat, position.lng]}
        draggable={true}
        ref={markerRef}
        eventHandlers={{ dragend: handleDragEnd }}
      />
    </MapContainer>
  );
}
